export default __webpack_public_path__ + "static/32-80382aad6728e59990ab1e79eda4ac4a.png";